export default {
  ABW: "LAC",
  AFG: "APC",
  AGO: "SSA",
  AIA: "LAC",
  ALB: "ECA",
  AND: "ECA",
  ARE: "MNA",
  ARG: "LAC",
  ARM: "ECA",
  ASM: "APC",
  ATA: "ROW",
  ATF: "ROW",
  ATG: "LAC",
  AUS: "APC",
  AUT: "EUE",
  AZE: "ECA",
  BDI: "SSA",
  BEL: "EUE",
  BEN: "SSA",
  BES: "LAC",
  BFA: "SSA",
  BGD: "APC",
  BGR: "EUE",
  BHR: "MNA",
  BHS: "LAC",
  BIH: "ECA",
  BLM: "LAC",
  BLR: "ECA",
  BLZ: "LAC",
  BMU: "LAC",
  BOL: "LAC",
  BRA: "LAC",
  BRB: "LAC",
  BRN: "APC",
  BTN: "APC",
  BVT: "ROW",
  BWA: "SSA",
  CAF: "SSA",
  CAN: "NAC",
  CCK: "APC",
  CHE: "EUE",
  CHL: "LAC",
  CHN: "GCH",
  CIV: "SSA",
  CMR: "SSA",
  COD: "SSA",
  COG: "SSA",
  COK: "APC",
  COL: "LAC",
  COM: "SSA",
  CPV: "SSA",
  CRI: "LAC",
  CUB: "LAC",
  CUW: "LAC",
  CXR: "APC",
  CYM: "LAC",
  CYP: "EUE",
  CZE: "EUE",
  DEU: "EUE",
  DJI: "SSA",
  DMA: "LAC",
  DNK: "EUE",
  DOM: "LAC",
  DZA: "MNA",
  ECU: "LAC",
  EGY: "MNA",
  ERI: "SSA",
  ESH: "MNA",
  ESP: "EUE",
  EST: "EUE",
  ETH: "SSA",
  FIN: "EUE",
  FJI: "APC",
  FLK: "LAC",
  FRA: "EUE",
  FRO: "ECA",
  FSM: "APC",
  GAB: "SSA",
  GBR: "EUE",
  GEO: "ECA",
  GHA: "SSA",
  GIB: "ECA",
  GIN: "SSA",
  GLP: "LAC",
  GMB: "SSA",
  GNB: "SSA",
  GNQ: "SSA",
  GRC: "EUE",
  GRD: "LAC",
  GRL: "ECA",
  GTM: "LAC",
  GUF: "LAC",
  GUM: "APC",
  GUY: "LAC",
  HKG: "GCH",
  HMD: "ROW",
  HND: "LAC",
  HRV: "EUE",
  HTI: "LAC",
  HUN: "EUE",
  IDN: "APC",
  IND: "APC",
  IOT: "SSA",
  IRL: "EUE",
  IRN: "MNA",
  IRQ: "MNA",
  ISL: "ECA",
  ISR: "MNA",
  ITA: "EUE",
  JAM: "LAC",
  JOR: "MNA",
  JPN: "APC",
  KAS: "APC",
  KAZ: "ECA",
  KEN: "SSA",
  KGZ: "ECA",
  KHM: "APC",
  KIR: "APC",
  KNA: "LAC",
  KOR: "APC",
  KWT: "MNA",
  LAO: "APC",
  LBN: "MNA",
  LBR: "SSA",
  LBY: "MNA",
  LCA: "LAC",
  LIE: "ECA",
  LKA: "APC",
  LSO: "SSA",
  LTU: "EUE",
  LUX: "EUE",
  LVA: "EUE",
  MAC: "GCH",
  MAF: "LAC",
  MAR: "MNA",
  MCO: "ECA",
  MDA: "ECA",
  MDG: "SSA",
  MDV: "APC",
  MEX: "NAC",
  MHL: "APC",
  MKD: "ECA",
  MLI: "SSA",
  MLT: "EUE",
  MMR: "APC",
  MNE: "ECA",
  MNG: "APC",
  MNP: "APC",
  MOZ: "SSA",
  MRT: "SSA",
  MSR: "LAC",
  MTQ: "LAC",
  MUS: "SSA",
  MWI: "SSA",
  MYS: "APC",
  MYT: "SSA",
  NAM: "SSA",
  NCL: "APC",
  NEC: "NES",
  NER: "SSA",
  NFK: "APC",
  NGA: "SSA",
  NIC: "LAC",
  NIU: "APC",
  NLD: "EUE",
  NOR: "EUE",
  NPL: "APC",
  NRU: "APC",
  NZL: "APC",
  OMN: "MNA",
  PAK: "APC",
  PAN: "LAC",
  PCN: "APC",
  PER: "LAC",
  PHL: "APC",
  PLW: "APC",
  PNG: "APC",
  POL: "EUE",
  PRI: "LAC",
  PRK: "APC",
  PRT: "EUE",
  PRY: "LAC",
  PSE: "MNA",
  PYF: "APC",
  QAT: "MNA",
  REU: "SSA",
  ROU: "EUE",
  RUS: "ECA",
  RWA: "SSA",
  SAU: "MNA",
  SDN: "SSA",
  SEN: "SSA",
  SGP: "APC",
  SGS: "LAC",
  SHN: "SSA",
  SLB: "APC",
  SLE: "SSA",
  SLV: "LAC",
  SMR: "ECA",
  SOM: "SSA",
  SPM: "LAC",
  SRB: "ECA",
  SSD: "SSA",
  STP: "SSA",
  SUR: "LAC",
  SVK: "EUE",
  SVN: "EUE",
  SWE: "EUE",
  SWZ: "SSA",
  SXM: "LAC",
  SYC: "SSA",
  SYR: "MNA",
  TCA: "LAC",
  TCD: "SSA",
  TGO: "SSA",
  THA: "APC",
  TJK: "ECA",
  TKL: "APC",
  TKM: "ECA",
  TLS: "APC",
  TON: "APC",
  TTO: "LAC",
  TUN: "MNA",
  TUR: "ECA",
  TUV: "APC",
  TWN: "GCH",
  TZA: "SSA",
  UGA: "SSA",
  UKR: "ECA",
  URY: "LAC",
  USA: "NAC",
  UZB: "ECA",
  VAT: "ECA",
  VCT: "LAC",
  VEN: "LAC",
  VGB: "LAC",
  VIR: "LAC",
  VNM: "APC",
  VUT: "APC",
  WLF: "APC",
  WSM: "APC",
  XKV: "ECA",
  YEM: "MNA",
  ZAF: "SSA",
  ZMB: "SSA",
  ZWE: "SSA",
} as const;
